var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03104 9.53104L1.53104 17.031C1.46136 17.1007 1.37863 17.156 1.28759 17.1937C1.19654 17.2314 1.09896 17.2508 1.00042 17.2508C0.901871 17.2508 0.804289 17.2314 0.713245 17.1937C0.6222 17.156 0.539474 17.1007 0.469792 17.031C0.400109 16.9614 0.344834 16.8786 0.307122 16.7876C0.26941 16.6965 0.25 16.599 0.25 16.5004C0.25 16.4019 0.26941 16.3043 0.307122 16.2132C0.344834 16.1222 0.400109 16.0395 0.469792 15.9698L7.4401 9.00042L0.469792 2.03104C0.329061 1.89031 0.25 1.69944 0.25 1.50042C0.25 1.30139 0.329061 1.11052 0.469792 0.969792C0.610522 0.829062 0.801394 0.75 1.00042 0.75C1.19944 0.75 1.39031 0.829062 1.53104 0.969792L9.03104 8.46979C9.10077 8.53945 9.15609 8.62216 9.19384 8.71321C9.23158 8.80426 9.25101 8.90186 9.25101 9.00042C9.25101 9.09898 9.23158 9.19657 9.19384 9.28762C9.15609 9.37867 9.10077 9.46139 9.03104 9.53104Z",
    fill: "#717173"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.b91eac98884299993538a2e3f7dc3605.svg";
export { ForwardRef as ReactComponent };